import React, { useState } from "react";
import AddPlus from "../../../assets/Add_Plus.svg";
import "../community.css";
import ShowAllDiscussionPosts from "../components/ShowAllDiscussionPosts";
import AddPost from "../modal/add-post";
const DiscussionAccordion = ({ question, handleAddPostData, getGeneralDiscussion }) => {
    const [showAddModal, setShowAddModal] = useState(false);

    const handleAddPost = () => {
        setShowAddModal(true);
    };

    const closeAddPost = (data) => {
        setShowAddModal(false);
        handleAddPostData(question.id, data);
    };
    return (
        <>
            <div className="accordion-container mt-2">
                <div className="accordion-item">
                    <div>
                        <div className="d-flex mt-2 justify-content-between accr">
                            <div className="add-post cursor-pointer" onClick={handleAddPost}>
                                <img crossOrigin="anonymous" src={AddPlus} style={{ marginRight: "10px" }}></img>
                                Reply to Post
                            </div>
                        </div>
                    </div>
                    <ShowAllDiscussionPosts communityDiscussion={question.general_community_discussion} handleAddPostData={handleAddPostData} getGeneralDiscussion={getGeneralDiscussion} />
                </div>
            </div>
            {showAddModal && <AddPost onClose={closeAddPost} questionId={question.id} question={question} isReply={false} isComment={true} getGeneralDiscussion={getGeneralDiscussion} />}
        </>
    );
};
export default DiscussionAccordion;
